import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { MazeScene } from "./MazeScene";
import { TrailingImage } from "./TrailingImage";

export class TransitionLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, onComplete: Function) {

        super(scene);

        GameVars.currentScene.time.addEvent({
            
            delay: 1750, callback: () => {

                const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
                darkLayer.fillStyle(0x131538, .65);
                darkLayer.setInteractive();
                darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
                this.add(darkLayer);

                const textMazeSolved = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH * .5, GameConstants.GAME_HEIGHT * .2, "texture_atlas_1", "text_maze_solved")
                    .setOrigin(.5)
                    .setScale(1, GameVars.scaleY);
                this.add(textMazeSolved);

                const titleLabel = new Phaser.GameObjects.Text(this.scene, textMazeSolved.x + 94, textMazeSolved.y - 74 * GameVars.scaleY, GameVars.currentLevel.toString(), {fontFamily: "Sarpanch-Black", fontSize: "80px", color: "#7efdff"});
                titleLabel.setScale(1, GameVars.scaleY);
                titleLabel.setShadow(0, 0, "#7efdff", 7.5, true, true);
                this.add(titleLabel);

                const timeNinja = new TrailingImage(this.scene, -35, GameConstants.GAME_HEIGHT * .55, "splash_char");
                this.add(timeNinja);

                const trailTween = timeNinja.start();

                trailTween.setCallback("onComplete", function (): void {

                    onComplete();
                    MazeScene.currentInstance.hideTransitionLayer();

                }, [null], this);
            }, callbackScope: this
        });
    }
}
